import { useMemo } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { useUserIsAdmin } from "./use-user-is-admin";

export function useAppAuthState() {
  const [user, isAuthLoading] = useAuthState(auth);
  const {
    userIsAdmin,
    loading: isAdminLoading,
    authedUserId,
  } = useUserIsAdmin();

  return useMemo(() => {
    const isLoggedIn = !!user?.emailVerified;
    const compoundIsAuthLoading = isAuthLoading || authedUserId !== user?.uid;
    return {
      unverifiedFireUser: user ?? null,
      fireUser: user?.emailVerified ? user : null,
      isUserAdmin: userIsAdmin && isLoggedIn,
      isAdminLoading: isAdminLoading || compoundIsAuthLoading,
      isLoggedIn,
      isAuthLoading: compoundIsAuthLoading,
    };
  }, [isAdminLoading, isAuthLoading, user, userIsAdmin, authedUserId]);
}
